<h2 mat-dialog-title>Experiencias profissionais</h2>
<mat-dialog-content>
  <div class="content">
    <div class="col-left">
      <div *ngIf="experiences.length === 0">
        <div class="empty-content">
          <p class="text-sm">Nenhuma experiencia profissional cadastrada</p>
        </div>
      </div>

      <ng-container *ngIf="experiences.length > 0">
        <mat-action-list>
          <h3 matSubheader>Meu histórico</h3>
          <ng-container *ngFor="let experience of experiences">
            <button
              mat-list-item
              (click)="editProfessionalExperience(experience)"
            >
              <h3 matLine>{{ experience.organization }}</h3>
              <p matLine>
                <span
                  >de {{ experience.init_date | date : "dd/MM/yyyy" }} até
                  {{
                    (experience.final_date | date : "dd/MM/yyyy") || "o momento"
                  }}</span
                >
              </p>
            </button>
          </ng-container>
        </mat-action-list>
      </ng-container>
    </div>

    <div class="col-right" *ngIf="currentExperience">
      <p class="text-sm" style="color: red">Apenas visualização</p>

      <form style="margin-top: 20px" [formGroup]="formVacancy">
        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Cargo desejado</mat-label>
            <input
              matInput
              type="text"
              placeholder="Digite para aparece as opções"
              formControlName="desiredJobTitle"
            />
          </mat-form-field>
        </div>

        <div class="row" style="margin-bottom: 10px">
          <mat-slide-toggle color="primary" formControlName="isPcd"
            >Usar vaga PCD</mat-slide-toggle
          >
        </div>

        <div class="row" *ngIf="formVacancy.get('isPcd').value">
          <mat-form-field appearance="outline">
            <mat-label>Qual a sua deficiência</mat-label>
            <mat-select
              formControlName="pcdDescription"
              placeholder="Escolha uma deficiência"
            >
              <ng-container *ngFor="let pcd of pcdList">
                <mat-optgroup
                  *ngIf="pcd.group; else pcdListDefault"
                  [label]="pcd.group"
                >
                  <ng-container *ngFor="let pcdDesc of pcd.list">
                    <mat-option [value]="pcd.group + ' - ' + pcdDesc.name">
                      <span
                        style="margin-right: 10px"
                        *ngIf="
                          formVacancy.get('pcdDescription').value ===
                          pcd.group + ' - ' + pcdDesc.name
                        "
                      >
                        <small>{{ pcd.group }} - </small>
                      </span>
                      <span>{{ pcdDesc.name }}</span>
                    </mat-option>
                  </ng-container>
                </mat-optgroup>
                <ng-template #pcdListDefault>
                  <mat-option [value]="pcd.default">{{
                    pcd.default
                  }}</mat-option>
                </ng-template>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- <div class="row">

                    <mat-form-field appearance="outline">
                        <mat-label>Empresa</mat-label>
                        <input matInput type="text" placeholder="Nome da empresa" formControlName="company"/>
                    </mat-form-field>
        
                </div>

                <div class="row">
    
                    <mat-form-field appearance="outline">
                        <mat-label>Setor</mat-label>                    
                        <input type="text"
                            id="vacancy"                            
                            placeholder="Informe seu setor"
                            matInput
                            formControlName="vacancy">                        
                    </mat-form-field>
        
                </div>

                <div class="row">
                    <mat-form-field appearance="outline">
                        <mat-label>Área</mat-label>
                        <input type="text"
                            id="specializationName"
                            placeholder="Informe sua função"
                            matInput
                            formControlName="specializationName">
                    </mat-form-field>
                </div>

                <div class="row">
                    <mat-form-field appearance="outline">
                        <mat-label>Cargo</mat-label>
                        <input type="text"
                            id="roleLevel"
                            placeholder="Informe o cargo"
                            matInput
                            formControlName="roleLevel">                        
                    </mat-form-field>
                </div>

                <div class="row">
                    <mat-form-field appearance="outline">
                        <mat-label>Ramo de atividade</mat-label>
                        <input type="text"
                            id="branch"
                            placeholder="Informe o ramo de atividade"                
                            matInput
                            formControlName="branch">                        
                    </mat-form-field>
                </div>

                <div class="row">
                    <mat-form-field appearance="outline">
                        <mat-label>Profissão</mat-label>
                        <input matInput placeholder="Informe a área de atuação" type="text" formControlName="office" />
                    </mat-form-field>
                </div>         -->

        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Cargo</mat-label>
            <input
              type="text"
              id="Sinonimo"
              (blur)="onBlurInput('sinonimo')"
              (focus)="onFocusInput('sinonimo')"
              placeholder="Cargo"
              (keyup)="_filterSinonimo($event.target.value)"
              matInput
              formControlName="sinonimo"
              [matAutocomplete]="autoSinonimo"
            />
            <mat-autocomplete #autoSinonimo="matAutocomplete">
              <mat-option
                *ngFor="let Sinonimo of filteredSinonimo"
                [value]="Sinonimo.Name"
              >
                {{ Sinonimo.Name }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="formVacancy.get('sinonimo').errors?.invalid"
              >Escolha um dos valores que aparecem na lista ao
              digitar</mat-error
            >
          </mat-form-field>
        </div>

        <div class="row" style="margin-bottom: 20px">
          <mat-slide-toggle color="primary" formControlName="currentJob"
            >Estou atualmente nesse emprego</mat-slide-toggle
          >
        </div>

        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Descrição do seu trabalho</mat-label>
            <textarea
              matInput
              placeholder="Descrição do seu trabalho (opcional)"
              formControlName="description"
              style="max-height: 150px; min-height: 150px"
            ></textarea>
            <mat-hint>Informe até 1000 caracteres</mat-hint>
          </mat-form-field>
        </div>

        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Data de admissão</mat-label>
            <input
              matInput
              placeholder="MM/AAAA"
              formControlName="admissionDate"
              type="text"
              mask="00/0000"
              inputmode="numeric"
            />
          </mat-form-field>
        </div>

        <ng-container *ngIf="formVacancy.get('currentJob').value === false">
          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>Data de saída</mat-label>
              <input
                matInput
                type="text"
                placeholder="MM/AAAA"
                formControlName="departureDate"
                mask="00/0000"
                inputmode="numeric"
              />
            </mat-form-field>
          </div>
        </ng-container>

        <div class="row">
          <mat-form-field appearance="outline">
            <mat-label>Último salário</mat-label>
            <input matInput type="text" placeholder="Seu último salário" currencyMask inputmode="numeric"
            formControlName="salary" />
          </mat-form-field>
        </div>
      </form>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button color="accent" mat-dialog-close>Fechar</button>
</mat-dialog-actions>
